import logo from '../../assets/logos/logo.svg';

export default function DashboardLogo({ className = 'h-10 w-auto max-w-[180px]' }) {
  return (
    <img
      src={logo}
      alt="Tevris"
      className={className}
      width={180}
      height={40}
    />
  );
}
